import { Component, OnInit, Optional, Inject } from '@angular/core';
import { DialogsBuscadorService } from './dialogs-buscador.service';
import { DialogsAlertComponent } from '../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { DialogsTercerComponent } from '../dialogs-tercer/dialogs-tercer.component';
import { Utils } from 'src/app/core/utils/utils';

@Component({
  selector: 'app-dialogs-buscador',
  templateUrl: './dialogs-buscador.component.html',
  styleUrls: ['./dialogs-buscador.component.scss']
})
export class DialogsBuscadorComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $mostrar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  dato : any;
  allTercer : any;
  mensajeprov: boolean = false;
  textoerror: string = "";

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogsBuscadorService: DialogsBuscadorService,
              @Optional() private dialogRef: MatDialogRef<DialogsBuscadorComponent>,
              public router: Router,
              private translateService: TranslateService,
              private dialog: MatDialog,
              private webservicesService: WebServicesService) { this.dialogsBuscadorService.build(); }

  ngOnInit() {
    this.mensajeprov = false;
    this.dialogsBuscadorService.init(this.data).subscribe(result => {
      this.loading = false;
    }, error => {
      console.log(error);
      this.dialogRef.close(true);
      this.loading = false;
      this.errorWebservice('WARNINGS.error_ws');
    });
  }

  /**
  * @description
  * Cierra el dialog
  */
  aceptar() {
    this.loading = true;
    this.mensajeprov = false;
    let proveidor: number = 0;
    let isproveidor: boolean;
    let iserrorprov: any;
    for (let i = 0; i < this.dialogsBuscadorService.allRols.length; i++) {
      if(this.dialogsBuscadorService.rols.code === this.dialogsBuscadorService.allRols[i].code ){
        proveidor = this.dialogsBuscadorService.allRols[i].proveidor;
      }
    }
    if(proveidor === 1){
      this.dialogsBuscadorService.isProveedor().subscribe(result => {
        isproveidor = _.cloneDeep(result.isproveedor);
        iserrorprov = _.cloneDeep(result.error);
        if(isproveidor){
          this.mostrar();
          this.dialogRef.close(true);
        }else{
          if(iserrorprov != null){
            let texto = this.translateService.instant('WARNINGS.error_ws_provee');
            this.textoerror = texto + this.dialogsBuscadorService.nif.bold();
          }else{
            let texto = this.translateService.instant('WARNINGS.error_buscador_prov');
            this.textoerror = texto + this.dialogsBuscadorService.nif.bold();
          }
          this.dialogsBuscadorService.nif = "";
          this.mensajeprov = true;
          this.loading = false;
        }
      }, error => {
        console.log(error);
        this.loading = false;
        this.dialogRef.close(true);
        this.errorWebservice('WARNINGS.error_ws');
      });
    }else{
      this.mostrar();
      this.dialogRef.close(true);
    }
  }

  /**
  * @description
  * recogemos el nif y el rol para pasarlos a la ruta especificada
  */
  public mostrar() {
    this.loading = true;
    let nif =  this.dialogsBuscadorService.nif.toLocaleUpperCase();
    let rol = this.dialogsBuscadorService.rols.code;
    let desc : string = "";
    for(let i = 0; i < this.dialogsBuscadorService.allRols.length; i++){
      if(rol === this.dialogsBuscadorService.allRols[i].code){
        desc = _.cloneDeep(this.dialogsBuscadorService.allRols[i].desc);
      }
    }

    this.dialogsBuscadorService.getTerceros(nif).subscribe(result => {
      this.allTercer = _.cloneDeep(result);
      if(result != null){
        //if(result.length > 1 && !Utils.isNifCifJuridico(nif)){
        if(result.length > 1){
          this.dialogoTercer(nif, rol, desc, result);
          //this.errorWebservice('WARNINGS.error_tercer_duplicado');
        }else{
          if(this.router.url === "/internal/home/webservices"){
            this.dato = {nif: nif, rol: rol, desc: desc, dboid: result[0].dboid, tercer: result}
            this.webservicesService.initView(this.dato).subscribe(res => {
              this.loading = false;
            }, error => {
              this.loading = false;
              this.errorWebservice('WARNINGS.error_ws');
              console.log("Error: " + error);
            });
            this.loading = false;
          }else{
            this.router.navigate(['/internal/home/webservices'], {state: {nif: nif, rol: rol, desc: desc, dboid: result[0].dboid, tercer: result}});
            this.loading = false;
          }
        }
      }else{
        let isCIF = Utils.isCifEmpresa3(nif);
        let isDNI = Utils.validateDNI3(nif);
        this.loading = false;
        if(isCIF == false && isDNI == false){
          this.errorWebservice('WARNINGS.error_interna');
        }else{
          this.errorvalidInterna();
        }
      }
    });
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorWebservice(error: string) {
    this.loading = false;
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorvalidInterna() {
    let texto1 = this.translateService.instant('WARNINGS.error_buscador_ciu');
    let niftexto = texto1 + this.dialogsBuscadorService.nif.toLocaleUpperCase().bold();
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para recoger el dboid del tercero seleccionado y pasar datos al servidor
  * @param nif nif/cif del usuario.
  * @param nif rol seleccionado.
  * @param desc descripcion para la cabecera (descripcion del rol).
  * @param dboid tercero seleccionado.
  */
  public dialogoTercer(nif: string, rol: string, desc: string, dboid: any){
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";

    const dialogRef = this.dialog.open(DialogsTercerComponent, {
    width: anchodisp,
    disableClose: true,
    hasBackdrop: true,
    data: { nif: nif, rol: rol, desc: desc, personsByIdNumCtrlDig: dboid }
    });
    dialogRef.afterClosed().subscribe(result => {
      let dboid = _.cloneDeep(result);
      if(dboid != undefined){
        if(this.router.url === "/internal/home/webservices"){
          this.dato = {nif: nif, rol: rol, desc: desc, dboid: dboid, tercer: this.allTercer}
          this.webservicesService.initView(this.dato).subscribe(res => {
            console.log(res);
            this.loading = false;
          }, error => {
            this.loading = false;
            this.errorWebservice('WARNINGS.error_ws');
            console.log("Error: " + error);
          });
          this.loading = false;
        }else{
          this.router.navigate(['/internal/home/webservices'], {state: {nif: nif, rol: rol, desc: desc, dboid: dboid, tercer: this.allTercer}});
          this.loading = false;
        }
      }
    });
  }

}
